<template>
<div id="app">
  <ion-alert-controller />
  <ion-toast-controller />
  <ion-loading-controller />
  <ion-action-sheet-controller />
  <ion-popover-controller />
  <ion-menu-controller />
  <ion-app>
    <ion-nav></ion-nav>
    <Menu :usuario="usuario" />
    <div class="ion-page" main>
      <router-view></router-view>
    </div>
  </ion-app>
</div>
</template>
<style>
@import '../public/global.scss';
</style>
<script>
import Api from '@/components/Api/Api'
import ApiOffline from '@/components/Api/ApiOffline'
import GuiTools from '@/models/GuiTools'
import Menu from '@/components/Menu/Menu'
import Vue from 'vue'
Vue.use(require('vue-moment'))
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: false
})

// Sobreescribir la función alert default
async function presentAlert(txt) {
  try {
    const alertController = document.querySelector('ion-alert-controller');
    await alertController.componentOnReady();

    const alert = await alertController.create({
      header: 'Aviso',
      subHeader: txt,
      //message: txt,
      buttons: ['OK']
    });
    return await alert.present();
  } catch (e) {
    console.error("No se pudo obtener la alerta secundaria")
    window.alert2(txt)
  }
}
window.alert2 = window.alert
window.alert = presentAlert

window.toast = async function(message = 'Toast', duration = 2000, color = 'primary', position = "top") {
  const toastController = document.querySelector('ion-toast-controller')
  duration = duration || 2000
  await toastController.componentOnReady()
  try {
    const toast = await toastController.create({
      message,
      duration,
      position,
      showCloseButton: true,
      closeButtonText: 'X',
      color,
      keyboardClose: true,
      mode: "ios"
    });
    return await toast.present()
  } catch (e) {
    alert(message)
  }
}

export default {
  name: 'App',
  components: {
    Menu
  },
  data() {
    return {
      usuario: Api.fetchLocal('cmms.yo') || {
        rol: 'invitado',
        nombre: 'Maqueta'
      },
      modoOffline: false
    }
  },
  methods: {
    async openEnd() {
      let u = document.querySelector('ion-menu-controller')
      console.log("Abriendo menú", u)
      u.enable(true, 'default')
      u.open('default')
      //await this.obtenerUsuario()
    },
    closeEnd() {
      let u = document.querySelector('ion-menu-controller')
      u.close('default')
    },
    async toggleModoOffline() {
      let modoOffline = Api.fetchLocal('cmms.modoOffline')
      if (typeof ApiOffline != 'undefined') {
        if (modoOffline == false) { // A punto de cambiarse a true. Obtener los datos.
          GuiTools.alert("Ha activado el modo Sin conexión. Si otro usuario también está Sin conexión y cambia datos previamente existentes (como productos o clientes), sólo los datos más nuevos prevalecerán.")
          await ApiOffline.syncFetch()
        } else { // A punto de cambiarse a false. Sincronizar.
          await ApiOffline.syncPush()
        }
      }
      Api.saveLocal('cmms.modoOffline', !modoOffline)
      setTimeout(async () => {
        window.location.reload()
      }, 2000)
    },
    logout() {
      Api.$emit('logged-in', {})
      this.$router.push('/login')
      this.closeEnd()
    }
  },
  mounted() {
    let vm = this
    Api.$on('open-menu', this.openEnd)
    Api.$on('close-menu', this.closeEnd)
    Api.$on('logged-in', usuario => {
      vm.usuario = usuario
      if (usuario && usuario._id)
        //Api.saveLocal('cmms.yo', usuario)
        console.log("Hola", usuario.email)
      if (this.$route.path.indexOf('/login') >= 0)
        this.$route.push('/')
      else {
        Api.deleteLocal('cmms.yo')
        Api.$emit('close-menu')
        this.$router.push('/login')
        alert("Sesión cerrada")
      }
    })
    // Si ya hay sesión, ir directo a ella
    let usuario = Api.fetchLocal('cmms.yo') || {}
    console.log("USR", usuario)
    if (!(usuario && usuario._id)) {
      //Api.$emit('logged-in', usuario)
      toast("No se ha encontrado sesión")
      vm.$router.push('/login')
      //window.location.reload()
    }
    //
    console.log("Vueonic app mounted")
  }
}
</script>
